import React, { useEffect, useState } from "react";
import { callBackend } from "../utils/api";
import { Skull } from "lucide-react";

export default function CrimeLogs() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    callBackend("/history/crimes").then(setLogs);
  }, []);

  return (
    <div className="bg-zinc-900 border-2 border-zinc-800 p-6 shadow-2xl font-mono">
      <h3 className="text-white font-black italic mb-4 uppercase flex items-center gap-2">
        <Skull size={18} className="text-green-500" /> Personal Scores
      </h3>
      <div className="space-y-2 max-h-60 overflow-y-auto">
        {logs.length === 0 && (
          <p className="text-zinc-600 italic text-xs">
            No felony logs recorded for this period.
          </p>
        )}
        {logs.map((log) => (
          <div
            key={log.id}
            className="text-[10px] border-l-2 border-zinc-700 pl-2 py-2"
          >
            <span className="text-zinc-500">
              [{new Date(log.created_at).toLocaleTimeString()}]
            </span>{" "}
            <span
              className={log.is_success ? "text-green-500" : "text-red-500"}
            >
              {log.is_success ? "SUCCESS" : "BUSTED"}
            </span>
            <p className="text-white mt-1 uppercase font-bold">
              HIT <span className="text-blue-400">{log.crime_name}</span> IN{" "}
              {log.district_name}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
